var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content provision-rule-tab" },
    [
      _c("div", { staticClass: "grid-view" }, [
        _c(
          "div",
          { staticClass: "main-content" },
          [
            _c(
              "search-item",
              {
                ref: "searchItem",
                attrs: {
                  "config-module": "25002001",
                  "show-simple": false,
                  "show-adv": true,
                  "expand-adv": true,
                  "auto-init": false,
                  "custom-search-items": _vm.customSearchItems
                },
                on: {
                  advSearchItemCallBack: _vm.onAdvancedQuery,
                  resetFields: _vm.onResetFields
                }
              },
              [
                _c(
                  "div",
                  { attrs: { slot: "operations" }, slot: "operations" },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.addHandler }
                      },
                      [_vm._v("新增")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.editHandler }
                      },
                      [_vm._v("编辑")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "primary" },
                        on: { click: _vm.toggleStatusHandler }
                      },
                      [_vm._v("启用/停用")]
                    ),
                    _c(
                      "el-button",
                      {
                        attrs: { type: "danger" },
                        on: { click: _vm.deleteHandler }
                      },
                      [_vm._v("删除")]
                    )
                  ],
                  1
                )
              ]
            ),
            _c(
              "div",
              { staticClass: "section grid-wrapper" },
              [
                _c("cargo-ag-grid", {
                  staticStyle: {
                    width: "100%",
                    height: "100%",
                    "min-height": "360px"
                  },
                  attrs: {
                    "grid-options": _vm.gridOptions,
                    "column-defs": _vm.columnDefs,
                    "row-data": _vm.pageRowData
                  },
                  on: {
                    gridReady: function(params) {
                      _vm.gridApi = params.api
                    }
                  }
                })
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "pagination-wrapper" },
              [
                _c("cargo-pagination", {
                  attrs: {
                    total: _vm.filter.total,
                    "page-count": _vm.pageCount,
                    page: _vm.filter.pageNum,
                    limit: _vm.filter.pageSize
                  },
                  on: {
                    "update:page": function($event) {
                      return _vm.$set(_vm.filter, "pageNum", $event)
                    },
                    "update:limit": function($event) {
                      return _vm.$set(_vm.filter, "pageSize", $event)
                    },
                    pagination: _vm.loadData
                  }
                })
              ],
              1
            )
          ],
          1
        )
      ]),
      _vm.ruleDialogVisible
        ? _c("rule-edit-dialog", {
            attrs: {
              visible: _vm.ruleDialogVisible,
              "rule-uuid": _vm.editingRuleUuid,
              scope: "position",
              "group-options": _vm.groupList
            },
            on: {
              "update:visible": function($event) {
                _vm.ruleDialogVisible = $event
              },
              success: _vm.loadData
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }